import { render } from "./receivingAddress.vue?vue&type=template&id=3b954c86&scoped=true"
import script from "./receivingAddress.vue?vue&type=script&lang=js"
export * from "./receivingAddress.vue?vue&type=script&lang=js"

import "./receivingAddress.vue?vue&type=style&index=0&id=3b954c86&scoped=true&lang=less"

import exportComponent from "D:\\wkb\\dev\\study\\盘雷\\lida-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b954c86"]])

export default __exports__